import React from 'react';
import { Zap, BarChart3, ShieldCheck, Heart, Gem, Leaf, Users, Globe, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LIFESTYLE } from '../data/mock';
import ProductBox from '../components/ProductBox';
import Reveal from '../components/Reveal';
import { useFlavour } from '../context/FlavourContext';

const VALUES = [
  { icon: Gem, t: 'QUALITY FIRST', d: 'Premium, carefully selected ingredients.' },
  { icon: Leaf, t: 'SCIENCE BACKED', d: 'A modern formula with proven ingredients.' },
  { icon: Users, t: 'REAL LIVES', d: 'Created for men, by people who understand men.' },
  { icon: Globe, t: 'A GLOBAL VISION', d: 'From Europe to the world.' },
];

export default function About() {
  const navigate = useNavigate();
  const { flavour } = useFlavour();
  return (
    <div className="pt-24">
      {/* hero */}
      <section className="relative min-h-[80vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src={LIFESTYLE.portraitBW} alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-5 w-full">
          <Reveal>
            <p className="font-cond tracking-[0.3em] text-white/50 mb-4">OUR STORY</p>
            <h1 className="font-display text-5xl md:text-8xl">MORE THAN<br />A SUPPLEMENT.<br /><span className="text-flavour flavour-transition">A MINDSET.</span></h1>
            <p className="text-white/70 mt-6 max-w-lg">S-MAN was created for men who want to feel their best, live with more confidence and enjoy life to the fullest. It's not just about performance — it's about energy, presence and self-belief, every day.</p>
            <div className="mt-8 flex flex-wrap gap-6">
              {[{i:Zap,l:'REAL INGREDIENTS'},{i:BarChart3,l:'REAL RESULTS'},{i:ShieldCheck,l:'REAL PEOPLE'},{i:Heart,l:'A BETTER YOU'}].map((b)=>(
                <div key={b.l} className="flex items-center gap-2"><b.i className="w-5 h-5" style={{color:flavour.primary}} /><span className="font-cond tracking-wide text-xs text-white/70">{b.l}</span></div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* values + mission */}
      <section className="py-20 md:py-28 bg-[#080808]">
        <div className="max-w-[1400px] mx-auto px-5 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="font-cond tracking-[0.25em]" style={{color:flavour.primary}}>OUR MISSION</p>
            <h2 className="font-display text-4xl md:text-6xl mt-2">EMPOWER<br /><span className="text-flavour flavour-transition">REAL MEN</span></h2>
            <p className="text-white/60 mt-4 max-w-md">We believe every man deserves to feel confident, energised and ready for whatever life brings. S-MAN is designed to support your lifestyle, so you can focus on what really matters.</p>
            <div className="mt-8 grid sm:grid-cols-2 gap-6">
              {VALUES.map((v)=>(
                <div key={v.t} className="flex gap-3"><v.icon className="w-7 h-7 shrink-0 text-white/70" strokeWidth={1.5} /><div><p className="font-cond tracking-wide">{v.t}</p><p className="text-sm text-white/50">{v.d}</p></div></div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={150} className="flex justify-center"><ProductBox flavourId={flavour.id} size="lg" /></Reveal>
        </div>
      </section>

      {/* vision */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0"><img src={LIFESTYLE.sunset} alt="" className="w-full h-full object-cover opacity-30" /><div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" /></div>
        <div className="relative max-w-[1400px] mx-auto px-5 text-center">
          <Reveal>
            <p className="font-cond tracking-[0.25em]" style={{color:flavour.primary}}>OUR VISION</p>
            <h2 className="font-display text-4xl md:text-6xl mt-2">A STRONGER <span className="text-flavour flavour-transition">TOMORROW</span></h2>
            <p className="text-white/60 mt-4 max-w-xl mx-auto">We aim to become a global reference in men's wellness, offering innovative, high-quality products that inspire a stronger, more confident generation.</p>
          </Reveal>
        </div>
      </section>

      {/* stats */}
      <section className="py-16 border-y border-white/10 bg-[#0a0a0a]">
        <div className="max-w-[1400px] mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {[['5','FLAVOURS'],['1','UNIQUE FORMULA'],['1000+','HAPPY CUSTOMERS'],['1','MISSION']].map(([n,l])=>(
            <div key={l}><p className="font-display text-5xl" style={{color:flavour.primary}}>{n}</p><p className="font-cond tracking-wide text-white/60 mt-1">{l}</p></div>
          ))}
        </div>
      </section>

      <section className="py-20 text-center">
        <button onClick={()=>navigate('/flavours')} className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#ff2d2d] text-white font-cond tracking-wide text-lg hover:brightness-110 transition-all">JOIN THE JOURNEY <ArrowRight className="w-5 h-5" /></button>
      </section>
    </div>
  );
}
